import { requestWithToken } from "../utils/apis";

export const storyMapList = async (page, limit) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/story-maps/list?page=${page}&limit=${limit}`
    );

    return response.data;
  } catch (err) {
    return err.response?.data;
  }
};

export const storyMapDetail = async (id) => {
  try {
    const response = await requestWithToken("GET", `/api/story-maps/${id}`);
    return response.data;
  } catch (err) {
    return err.response?.data;
  }
};

export const deleteStoryMap = async (id) => {
  try {
    const response = await requestWithToken("DELETE", `/api/story-maps/${id}`);
    return response.data;
  } catch (err) {
    return err.response?.data;
  }
};

